import React from "react";
import PopUpHeader from "./PopUpHeader";

type TFieldProps = {
    id?: string;
    title?: string
    content: any
    projectId?: string
    onClose?: () => void;
    onSuccess?: (id:string) => void;
}

const PopUp = ({id, title, content}: TFieldProps) => {
    const baseId = id || 'ui-model-popup';
    return (
        <div id={baseId} data-testid={baseId} className={`tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-400 tw-bg-opacity-50 tw-z-50`}>
            <div id={`${baseId}-modal`} className={`tw-bg-white tw-rounded tw-shadow-md tw-w-auto tw-h-auto tw-border tw-border-[#c9cccf]`}>
                <PopUpHeader id={`${baseId}-header`} title={title} />
                {content}
            </div>
        </div>
    );
}

export default PopUp;